// Copyright (c) 2016 Deere & Company

import busyCounter from './busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import filteredSearchResults from './filtered-search-results';
import searchByDropdown from './search-by-dropdown';
import searchFilters from './search-filters';
import searchQueryString from './search-query-string';
import searchResults from './search-results';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    facets,
    filteredSearchResults,
    searchByDropdown,
    searchFilters,
    searchQueryString,
    searchResults
});



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/index.js